import React from 'react';
import CapNotification from '../../CapNotification';
import { rootClsPrefix as clsPrefix } from '../constants';

const Notification = ({ className, ...rest }) => {
    return (
        <CapNotification
            className={`${clsPrefix}-notification ${className}`}
            {...rest}
        />
    );
};

export { Notification };
export const NotificationMethods = CapNotification;
